









import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { IConditionalExpressionBehavior, IConditionalExpressionContent, ExpressionKinds } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { CalculateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class ConditionalExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: IConditionalExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IConditionalExpressionBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get contents(): IConditionalExpressionContent[] {
    return this.readPropertyOrDefault(s => s.contents, []);
  }

  set contents(value: IConditionalExpressionContent[]) {
    this.writePropertyWhenValid(s => s.contents = value);
  }

  get selectionObjects(): IFormatObjectEditable[] {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .where(o => this.conditionsOfEachElementType(o))
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    switch (object.objectTypeName().getValue()) {
      case "text":
      case "tag":
      case "scriptlink":
      case "jointext":
      case "combo":
      case "roll":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
      case "check":
      case "circleselect":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && !!linkedObject.subKey && linkedObject.subKey !== "";
      case "script":
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && !!linkedObject.tableIndex && linkedObject.tableIndex.row === 0 && linkedObject.tableIndex.column === 0;
      case "calculate":
        const kind = (object instanceof CalculateObjectEditor) ? object.kind().getValue() : null;
        return !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "" && (kind === ExpressionKinds.Calculation || kind === ExpressionKinds.DateDuration);
      default:
        return false;
    }
  }

  async showConditionalExpressionContentEditDialog() {
    const dialog = this.commonComponents.getDialogs().getConditionalExpressionContentEditDialog();
    const expressionContents = await dialog.show(this.contents, this.selectionObjects);
    if (!expressionContents) { return; }
    this.contents = expressionContents;
  }
}
